import { modifier } from 'ember-modifier';

export default modifier(function scrollPosition(element, positional, named) {
  if (named.direction === 'left') {
    if ('percentage' in named) {
      element.scrollLeft = element.scrollWidth * named.percentage;
    } else if ('value' in named) {
      element.scrollLeft = named.value;
    }
  }
});
